// extracted by mini-css-extract-plugin
module.exports = {"heroContent":"HeroContent_heroContent__z_bqP"};